module.exports = __webpack_public_path__ + "media/images/area/area_yamagataM400-ab9be8952ab0f311ad8e2cd3ed7269b9.jpg";